var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 162,
    viewBox: "0 0 215 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.306 29.7C157.156 29.7 151.794 33.75 151.794 39.15C151.794 44.55 157.156 48.6 164.306 48.6C171.456 48.6 176.819 44.55 176.819 39.15C176.819 33.75 171.456 29.7 164.306 29.7Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M108 41.8501C78.5063 41.8501 55.2688 60.0751 55.2688 81.6751C55.2688 103.275 79.4 121.5 108 121.5C136.6 121.5 160.731 103.275 160.731 81.6751C160.731 60.0751 137.494 41.8501 108 41.8501ZM108 107.325C89.2313 107.325 74.0375 95.8501 74.0375 81.6751C74.0375 67.5001 89.2313 56.0251 108 56.0251C126.769 56.0251 141.963 67.5001 141.963 81.6751C141.963 95.8501 126.769 107.325 108 107.325Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M150.9 0H65.9938C29.35 0 0.75 21.6 0.75 48.6V112.725C0.75 139.725 29.35 161.325 65.1 161.325H150.006C185.756 161.325 214.356 139.725 214.356 112.725V48.6C215.25 21.6 186.65 0 150.9 0ZM194.694 113.4C194.694 131.625 175.031 147.15 150.006 147.15H65.1C40.9687 147.15 20.4125 132.3 20.4125 113.4V49.275C20.4125 31.05 40.075 15.525 65.1 15.525H150.006C174.138 15.525 194.694 30.375 194.694 49.275V113.4Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.40d287eb185ff29f33a55df98fd01d71.svg";
export { ForwardRef as ReactComponent };